import { render, staticRenderFns } from "./textArea.vue?vue&type=template&id=7a735bee&scoped=true"
import script from "./textArea.vue?vue&type=script&lang=js"
export * from "./textArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a735bee",
  null
  
)

export default component.exports